var exports = {
  "kL": "xfd349460--5d4204--container",
  "tM": "xfd349460--5d4204--with-icon",
  "Kk": "xfd349460--5d4204--icon",
};

module.exports = exports;
